module.exports = __webpack_public_path__ + "media/application/images/2018/2018-facebook-icon-8c8868b9e06e2494c4e198d32159c6f7.svg";